import { createActionCreator } from "deox";

export const newUserSuccess = createActionCreator("newUserSuccess");
